export default{
    wcOrderDetail:{
        table:{
            tab1:'Order Number',
            tab2:'Merchant Name',
            tab3:'Order Amount',
            tab4:'Refund Amount',
            tab5:'Payable Amount', 
            tab6:'Action',
            tab7:'Select All',
        },
        msgState:{
            msg1:'3 orders selected',
            msg2:'Total Payable:',
        },
        btnState:{
            btn1:'View Details',
            btn2:'Early Settlement',
            btn3:'Settle Early',
        },
        confirmState:{
            confirm1:'Notification',
            confirm2:'Confirm',
            confirm3:'Cancel',
            confirm4:'Cancelled',
            confirm5:'Require invoice from merchant?',
            confirm6:'No Invoice',
            confirm7:'Require Invoice',
        }
    }
}